export const keyCodes = {
  SPACEBAR: 32,
  ENTER: 13,
  UP: 38,
  DOWN: 40,
  ESCAPE: 27,
  TAB: 9,
};
